import CommonButton from 'components/Buttons/CommonButton';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';

const ViewPreviousDocuments = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const protocol = useSelector(selectors.documents.selectActiveDocumentID);
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  return (
    <CommonButton
      id="view-previous-documents-btn"
      action={() => dispatch(actions.modal.openModal(actionType.VIEW_PREVIOUS_DOCUMENTS))}
      scope="tertiary"
      value={t('ViewPreviousDocuments')}
      disabled={!utils.user.isActionEnabled(records, actionType.VIEW_PREVIOUS_DOCUMENTS) || !protocol}
      customIcon="eye"
    />
  );
};

export default ViewPreviousDocuments;
